import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type EditorState = {
  isOpen: boolean;
  userId: string | null; // null => Add mode, string => Edit mode
};

const initialState: EditorState = { isOpen: false, userId: null };

const userEditorSlice = createSlice({
  name: "userEditor",
  initialState,
  reducers: {
    openEditor: (state, action: PayloadAction<string | null>) => {
      state.isOpen = true;
      state.userId = action.payload;
    },
    closeEditor: (state) => {
      state.isOpen = false;
      state.userId = null;
    },
  },
});

export const { openEditor, closeEditor } = userEditorSlice.actions;
export default userEditorSlice.reducer;
